import EgoBalance from "../images/ego_balance.jpg";
import Hfc1 from "../images/hfc_1.jpg";
import Hfc2 from "../images/hfc_2.jpg";
import Kundalini from "../images/kundalini.jpg";
import HumanPotential from "../images/human_potential.jpg";

const serviceImages = {
  "ego_balance.jpg": EgoBalance,
  "hfc_1.jpg": Hfc1,
  "hfc_2.jpg": Hfc2,
  "kundalini.jpg": Kundalini,
  "human_potential.jpg": HumanPotential,
};

export default serviceImages;
